"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const i18next_1 = __importDefault(require("i18next"));
const i18next_http_backend_1 = __importDefault(require("i18next-http-backend"));
const i18next_browser_languagedetector_1 = __importDefault(require("i18next-browser-languagedetector"));
const react_i18next_1 = require("react-i18next");
const IS_PRODUCTION = process.env.NODE_ENV === 'production';
const options = {
    fallbackLng: 'en',
    debug: !IS_PRODUCTION,
    returnEmptyString: true,
    interpolation: {
        escapeValue: false,
    },
    react: {
        useSuspense: false,
    },
    backend: {
        loadPath: `${window.document.baseURI}/locales/{{lng}}/{{ns}}.json`,
    },
};
i18next_1.default
    // we use the server to serve locale files (statically)
    .use(i18next_http_backend_1.default)
    .use(i18next_browser_languagedetector_1.default)
    .use(react_i18next_1.initReactI18next)
    .init(options);
exports.default = i18next_1.default;
